import { get, values, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getDownloadRequest = get('downloadRequest');

export const getAll = createSelector(getDownloadRequest, get('all'));

export const getDownloadRequestResultById = createSelector(
  getDownloadRequest,
  get('resultById')
);

export const getAllValues = createSelector(getAll, values);

export const getOrderedDownloadRequests = createSelector(
  getAllValues,
  orderBy('createdAt', 'desc')
);

export const getDownloadRequestForId = createSelector(
  (_, id) => id,
  getAll,
  get
);

export const getDownloadRequestResultForId = createSelector(
  (_, id) => id,
  getDownloadRequestResultById,
  get
);

export const getDownloadRequestsQuery = createSelector(
  getDownloadRequest,
  get('query')
);

export const getIsFetching = createSelector(
  getDownloadRequest,
  get('fetching')
);
export const getIsFetched = createSelector(getDownloadRequest, get('fetched'));
export const getFetchingError = createSelector(
  getDownloadRequest,
  get('fetchingError')
);

export const getIsSaving = createSelector(getDownloadRequest, get('saving'));
export const getIsSaved = createSelector(getDownloadRequest, get('saved'));
export const getSavingError = createSelector(
  getDownloadRequest,
  get('savingError')
);

export const getIsFetchingResult = createSelector(
  getDownloadRequest,
  get('fetchingResult')
);
export const getIsFetchedResult = createSelector(
  getDownloadRequest,
  get('fetchedResult')
);
export const getFetchingResultError = createSelector(
  getDownloadRequest,
  get('fetchingResultError')
);

export const getOrder = createSelector(getDownloadRequest, get('order'));

export const getIsDeleting = createSelector(
  getDownloadRequest,
  get('deleting')
);
export const getIsDeleted = createSelector(getDownloadRequest, get('deleted'));
export const getDeletingError = createSelector(
  getDownloadRequest,
  get('deletingError')
);
